import { SxProps, Theme } from '@mui/material';

/**
 * HITL-1649 — the two cart-level action buttons, styled from one object.
 *
 * `Copy all to My Cart` (foot of LIVE ORDER) and `Take over with My Cart` (foot
 * of MY CART) are a pair: same size, same place, one per column, and a double
 * chevron each pointing at the column the items land in —
 *
 *     MY CART  [ Take over with My Cart >> ]  |  [ << Copy all to My Cart ]  LIVE ORDER
 *
 * — which is My Cart on the left (`Panel order={1}`) and the Live order on the
 * right, so the two arrows genuinely oppose each other on screen. Each sits on
 * the side of its label that it points at, which is why one is an `endIcon` and
 * the other a `startIcon`. They are
 * defined here rather than twice because "similar" is not a property two
 * separate style blocks can keep — the moment one is adjusted the pair stops
 * reading as a pair.
 *
 * `sx` (emotion) rather than a `makeStyles` class, and that is the whole of why
 * the takeover shipped as `TAKE OVER WITH MY CART`. MUI v5 injects
 * `.MuiButton-root { text-transform: uppercase }` through emotion, and this app
 * mounts no `StyledEngineProvider injectFirst` — so an `@mui/styles` rule at
 * equal specificity LOSES. `promoteButton` declared `textTransform: 'none'` and
 * it simply never applied. The same trap is documented at
 * `DraftCartItemReview.content` (HITL-1619).
 */
export const CART_ACTION_BUTTON_SX: SxProps<Theme> = {
  width: '100%',
  fontSize: '0.7rem',
  // Sentence case, as written in the label — an order-console button reads as a
  // phrase the agent is about to do, not as a shout.
  textTransform: 'none',
  // The chevron sits at the label's own size rather than MUI's default 20px,
  // which on a 0.7rem button reads as an icon with a caption attached. Matches
  // whichever slot it is in — `MuiButton-startIcon` or `-endIcon`.
  '& .MuiSvgIcon-root': { fontSize: '0.9rem' },
};
